import { createSelector } from '@ngrx/store';
import { roleRegisterSelector } from './role-register.reducer';

export const selectRoleRegisterIncludeInactive = createSelector(roleRegisterSelector, (state) => {
   return state.includeInactive;
});

export const selectFilters = createSelector(roleRegisterSelector, (state) => {
   return state.filters;
});

export const selectIsOnSystemPage = createSelector(roleRegisterSelector, (state) => {
   return state.isOnSystemPage;
});
